"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _Item = _interopRequireDefault(require("./components/Item"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _GeoTreeList = function GeoTreeList(_ref) {
  var countryID = _ref.countryID,
    rootType = _ref.rootType,
    rootName = _ref.rootName,
    rootID = _ref.rootID,
    rootParentID = _ref.rootParentID,
    items = _ref.items;
  return /*#__PURE__*/_react.default.createElement(_Item.default, {
    countryID: countryID,
    hasChildren: Boolean(items),
    id: rootID,
    name: rootName,
    parentID: rootParentID,
    type: rootType
  }, function (open) {
    return open && Boolean(items) && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.list
    }, R.map(function (item) {
      return item.children ? /*#__PURE__*/_react.default.createElement(_GeoTreeList, {
        countryID: countryID,
        items: item.children,
        key: "list-".concat(item.id),
        rootID: item.id,
        rootName: item.name,
        rootParentID: item.parentID,
        rootType: item.type
      }) : /*#__PURE__*/_react.default.createElement(_Item.default, {
        countryID: countryID,
        hasChildren: false,
        id: item.id,
        key: item.id,
        name: item.name,
        parentID: item.parentID,
        type: item.type
      });
    }, items));
  });
};
var _flattenTree = function flattenTree(tree) {
  return R.reduce(function (results, item) {
    return R.concat(R.append(R.omit(['children'], item), results), item.children ? _flattenTree(item.children) : []);
  }, [], tree);
};
var searching = function searching(search, tree) {
  return R.filter(function (_ref2) {
    var name = _ref2.name;
    return R.includes(R.toLower(search), R.toLower(name));
  }, tree);
};
var GeoTreeControl = function GeoTreeControl(_ref3) {
  var countryID = _ref3.countryID,
    tree = _ref3.tree;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var treeBySearch = (0, _react.useMemo)(function () {
    return searching(search, _flattenTree(tree));
  }, [search, tree]);
  var handleClear = (0, _react.useCallback)(function () {
    return setSearch('');
  }, []);
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.geoTreeWrapper
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    text: t('GEO_TREE_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.container
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    placeholder: t('GEO_TREE_SEARCH_CONTROL_LABEL'),
    value: search,
    onChange: setSearch,
    onClear: handleClear
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.mainList
  }, R.map(function (_ref4) {
    var id = _ref4.id,
      name = _ref4.name,
      parentID = _ref4.parentID,
      type = _ref4.type,
      children = _ref4.children;
    return /*#__PURE__*/_react.default.createElement(_GeoTreeList, {
      countryID: countryID,
      items: children,
      key: "list-".concat(id),
      rootID: id,
      rootName: name,
      rootParentID: parentID,
      rootType: type
    });
  }, search ? treeBySearch : tree)))));
};
GeoTreeControl.propTypes = {
  countryID: _propTypes.default.string.isRequired,
  tree: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    name: _propTypes.default.string.isRequired,
    type: _propTypes.default.string.isRequired,
    parentID: _propTypes.default.number,
    children: _propTypes.default.array
  })).isRequired
};
var _default = exports.default = (0, _react.memo)(GeoTreeControl);